var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-auto"},[_c('b-spinner',{staticClass:"mt-5",attrs:{"variant":"primary"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }